import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button } from "../../../components/Buttons";

export const Profit = () => {
    document.title = "Mənfəət";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Hesabatlar", value: "/reports" },
        { name: "Mənfəət", value: "/reports/profit" },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Mənfəət</h2>
                    <p>
                        Mənfəət hesabatı müəyyən bir müddət ərzində malların <mark>topdan</mark> və <mark>pərakəndə</mark> satışları və qaytarmalarından əldə
                        olunan <mark>gəlir</mark>i və <mark>marja</mark>sıdır.
                        <ul>
                            <li>
                                Məhsulun satışından olan <b>qazancı</b>, <b>maya</b> dəyərinin <b>satış</b> qiymətinə olan fərqi və qiymət siyasətinin
                                göstəricisidir
                            </li>
                            <li>
                                İstifadəçinin satışları və qaytarmaları hesablanaraq <b>qazanc</b> və <b>marja</b> barədə mənfəət hesabatı təqdim etmək üçün
                                nəzərdə tutulub
                            </li>
                        </ul>
                        Nümunədə Hesabatlar ⮞ Mənfəət səhifəsinə baxmaq üçün ardıcıllıq göstərilib
                        <br />
                        <Button>Filter</Button> düyməsini sıxıb, lazım olan xanaları doldurub, <Button>Axtar</Button> düyməsini sıxmaq lazımdır.
                    </p>
                    <img src="/images/reports/profit.gif" alt="Mənfəət" />
                </article>
            </div>
        </div>
    );
};
